<template lang="pug">
div
  h1 Timeline

  version-filter(
    key="versionFilter",
    @change="versionChanged",
    :disabled="this.loading"
  )

  environment-filter(
    key="environmentFilter",
    @change="environmentChanged",
    :disabled="this.loading"
  )

  button(@click="fetchAnalyticsData", v-if="!this.loading") Re-fetch Data
  span(v-else) Loading ...
  br
  br
  div(v-if="!analyticsData")
    br
    p Press 'Fetch Data' to retrieve analytics data (might take a while)
  div(v-else)

    div.timeline(:style="{ height: (Math.pow(Math.max(0, sortedTimelineEntries[sortedTimelineEntries.length - 1][0] - 60) * 4, 0.7) + 100) + 'px'}")
        div(v-for="[time, type, title] of sortedTimelineEntries",class="timelineEntry",:class="'type-'+type",:style="{ top: Math.pow(Math.max(0, time - 60) * 4, 0.7) + 'px'  }")
            .text {{ type }} / {{ title }}
            .time {{formatSecondsShort(time)}}

</template>

<script>
// import Vue from "vue";
import ApiService from "@/services/api";
import KeyStatBox from "@/components/KeyStatBox";
import DateFilter from "@/components/DateFilter";
import VersionFilter from "@/components/VersionFilter";
import EnvironmentFilter from "@/components/EnvironmentFilter";

import {
  formatBigNumber,
  formatSecondsShort,
  formatPercentage
} from "../utils";

export default {
  components: { KeyStatBox, DateFilter, VersionFilter, EnvironmentFilter },
  data: () => ({
    loading: false,
    version: null,
    environment: null,
    analyticsData: null,
    upgrades: ['belt', 'miner', 'processors', 'painting'],
  }),
  mounted() {
  },
  computed: {
    sqlVersionFilter() {
      if (this.version === '*') {
        return "true";
      }
      return "version = ~version";
    },

    sqlEnvironmentFilter() {
      if (this.environment === '*') {
        return "true";
      }
      return "environment = ~environment";
    },

    sqlFilters() {
      return this.sqlVersionFilter + " and " + this.sqlEnvironmentFilter;
    },

    sortedTimelineEntries() {

      const entries = [];

      // levels
      for (let i = 1; i < 18; ++i) {
        const time = this.p("level_" + i + "_time").avg;
        if (time !== 0) {
          entries.push([time, "level", i]);
        }
      }

      // upgrades
      for (const upgradeId of this.upgrades) {
        for (let i = 1; i < 6; ++i) {
          const time = this.p("upgrade_" + upgradeId + "@" + i + "_time").avg;
          if (time !== 0) {
            entries.push([time, "upgrade", upgradeId + " level " + i]);
          }
        }
      }
      return entries.sort((a, b) => a[0] - b[0]);
    },
  },

  methods: {
    formatBigNumber,
    formatSecondsShort,
    formatPercentage,

    p(id) {
      return this.analyticsData[id] || {
        count: 0,
        sum: 0,
        avg: 0
      };
    },

    p_nulled(id, count_id) {
      const count = this.p(count_id).count;
      const sum = this.p(id).sum;
      console.log(id, count_id, "->", sum, count);
      return sum / Math.max(1, count);
    },


    versionChanged(version) {
      console.log("Version changed:", version);
      this.version = version;
      this.fetchAnalyticsData();
    },

    environmentChanged(environment) {
      console.log("Environment changed:", environment);
      this.environment = environment;
      this.fetchAnalyticsData();
    },

    async fetchAnalyticsData() {
      this.analyticsData = null;

      if (!this.version || !this.environment) {
        return;
      }

      this.loading = true;

      const data = await ApiService.query('select key, sample_count::float8, sample_sum::float8 from aggregated_stats where ' + this.sqlFilters, {
        version: this.version,
        environment: this.environment
      });


      const result = {};

      data.forEach(({ key, sample_count, sample_sum }) => {
        if (!result[key]) {
          result[key] = {
            count: sample_count,
            sum: sample_sum,
          }
        } else {
          result[key].count += sample_count;
          result[key].sum += sample_sum;
        }
      });

      for (const key in result) {
        result[key].avg = result[key].sum / Math.max(1, result[key].count);
      }
      this.analyticsData = result;


      this.loading = false;
    },
  }
};
</script>

<style lang="scss" scoped>
.timeline {
  padding-left: 10px;
  margin-left: 100px;
  position: relative;
  border-left: 2px solid #aaa;
  display: flex;
  flex-direction: column;
  min-height: 6000px;

  > .timelineEntry {
    position: absolute;

    background: #333;
    color: #fff;
    padding: 5px;
    border-radius: 2px;
    font-size: 14px;
    z-index: 10;
    &:hover {
      z-index: 20;
    }

    .time {
      position: absolute;
      left: -130px;
      color: #333;
      top: 4px;
      text-align: right;
      width: 100px;
    }

    &:after {
      bottom: 100%;
      border: solid transparent;
      content: " ";
      height: 0;
      width: 0;
      position: absolute;
      pointer-events: none;
    }

    &:after {
      border-color: transparent;
      border-right-color: #333;
      border-width: 10px;
      bottom: 50%;
      margin-bottom: -10px;
      margin-left: -20px;
    }
  }
}

.type-level {
  color: green;
}
</style>
